import React from "react";
import "./RummyTableHistoryInnerRoundCards.css";
import { Modal } from "react-bootstrap";

const getSuitSymbol = (suit) => {
  switch (suit) {
    case "C":
      return "♣";
    case "D":
      return "♦";
    case "H":
      return "♥";
    case "S":
      return "♠";
    default:
      return suit;
  }
};

const getRankName = (rank) => {
  switch (String(rank)) {
    case "1":
      return "A";
    case "11":
      return "J";
    case "12":
      return "Q";
    case "13":
      return "K";
    default:
      return rank;
  }
};

function parseCards(name) {
  try {
    // Your stored value:
    // {"rank":"4",...}, {"rank":"7",...}

    return JSON.parse(`[${name}]`);
  } catch (error) {
    console.error("Card parse error:", error);
    return [];
  }
}

function PlayingCard({ card }) {
  const isPrintedJoker = String(card?.rank).toLowerCase() === "joker";

  if (isPrintedJoker) {
    return (
      <div className="rc-card rc-printed-joker" title="Printed Joker">
        <span className="rc-pj-star">♛</span>
        <span className="rc-pj-text">JOKER</span>
      </div>
    );
  }

  const suit = getSuitSymbol(card.suit);
  const rank = getRankName(card.rank);
  const isRed = card.suit === "H" || card.suit === "D";

  return (
    <div
      className={`rc-card ${isRed ? "rc-red" : "rc-black"} ${
        card.is_joker ? "rc-wild" : ""
      }`}
      title={card.is_joker ? `${rank}${suit} · Joker` : `${rank}${suit}`}>
      <div className="rc-corner">
        <span className="rc-rank">{rank}</span>
        <span className="rc-corner-suit">{suit}</span>
      </div>

      <div className="rc-center-suit">{suit}</div>

      {card.is_joker && <span className="rc-joker-badge">JOKER</span>}
    </div>
  );
}

function RummyTableHistoryInnerRoundCards(props) {
  const { rummyWalletHistoryCards, ...modalProps } = props;
  const cardsData = rummyWalletHistoryCards || [];

  return (
    <div className="Successfull_Modal_sec">
      <Modal
        className="Successfull_Modal rc-modal"
        {...modalProps}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered>
        <Modal.Header closeButton>
          <Modal.Title>Player Cards</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {cardsData.length > 0 ? (
            <div className="rc-groups">
              {cardsData.map((item, index) => {
                const cards = parseCards(item?.name);

                return (
                  <div className="rc-group" key={item.id || index}>
                    <div className="rc-hand">
                      {cards.length > 0 ? (
                        cards.map((card, cardIndex) => (
                          <PlayingCard card={card} key={cardIndex} />
                        ))
                      ) : (
                        <span className="rc-empty">No cards</span>
                      )}
                    </div>

                    <div className="rc-group-label">
                      <span>Group {index + 1}</span>
                      <span className="rc-count">
                        {cards.length} {cards.length === 1 ? "card" : "cards"}
                      </span>
                    </div>
                  </div>
                );
              })}
            </div>
          ) : (
            <div className="rc-empty rc-empty-all">No round history found</div>
          )}
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default RummyTableHistoryInnerRoundCards;
